import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      const component = document.querySelector( '.repeatable-comparison-list' );
      if ( !component ) return;

      const vehicleRow = component.querySelector( '.rcl__vehicle-row' );

      function getVehicleRowHeight() {
        return ( window.innerWidth >= 1024 && vehicleRow ) ? vehicleRow.offsetHeight : 0;
      }

      function getTopOffset() {
        let offset = $( '.navbar' ).outerHeight() || 0;
        if ( $( '#wpadminbar' ).length ) {
          offset += $( '#wpadminbar' ).outerHeight();
        }
        return offset;
      }

      function updateLayout() {
        component.style.setProperty( '--rcl-vehicle-row-height', getVehicleRowHeight() + 'px' );
      }

      updateLayout();

      // Intercept clicks to scroll precisely at click time (vehicle row may have grown after images loaded)
      component.querySelectorAll( '.rcl__nav-link' ).forEach( function( link ) {
        link.addEventListener( 'click', function( e ) {
          e.preventDefault();
          const target = component.querySelector( this.getAttribute( 'href' ) );
          if ( !target ) return;
          const offset = getTopOffset() + getVehicleRowHeight();
          const top = target.getBoundingClientRect().top + window.pageYOffset - offset + 8;
          window.scrollTo( {top, behavior: 'smooth'} );
          component.querySelectorAll( '.rcl__nav-link' ).forEach( function( l ) {
            l.removeAttribute( 'aria-current' );
          } );
          this.setAttribute( 'aria-current', 'location' );
        } );
      } );

      if ( window.innerWidth >= 1024 ) {
        const topOffset = getTopOffset() + getVehicleRowHeight();

        component.querySelectorAll( '.rcl__row' ).forEach( function( row ) {
          const rowKey = row.id.replace( 'rcl-row-', '' );
          const navLink = component.querySelector( '#rcl-nav-link-' + rowKey );

          ScrollTrigger.create( {
            trigger: row,
            start: `top top+=${topOffset}`,
            end: `bottom top+=${topOffset}`,
            toggleClass: {targets: navLink, className: 'is-active'},
            onToggle: function( self ) {
              if ( navLink ) {
                if ( self.isActive ) {
                  navLink.setAttribute( 'aria-current', 'location' );
                } else {
                  navLink.removeAttribute( 'aria-current' );
                }
              }
            },
          } );
        } );
      }

      const onResizeDebounce = new app.components.common.Debounce( function() {
        updateLayout();
        ScrollTrigger.refresh();
      }, 150 );

      window.addEventListener( 'resize', function() {
        onResizeDebounce.run();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'repeatable-comparison-list', COMPONENT );
} )( app );
